// extracted by mini-css-extract-plugin
module.exports = {"emphasis":"df34773e fw6 black-70","stepsToCorrect":"_2d21eb6a"};